import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  position: relative;
  height: 100%;
  display: grid;
  grid-template-rows: 25px 1fr;
  text-align: center;
  overflow-y: hidden;
`

export const Contents = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  height: 100%;
  display: flex;
  flex: 1;
  padding: 5px;
  overflow-y: auto;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  color: ${props => props.theme.colors.color6b7786};
  table {
    width: 100%;

    span {
      font: normal normal normal 12px/14px Inter;
      margin: 0 5px 0 5px;
      strong {
        font: normal normal bold 12px/14px Inter;
      }
    }
    .footerInfos {
      text-align: left;
    }
  }
  tr {
    width: 100%;
    display: grid;
    grid-template-columns: 70% 30%;
    text-align: left;
    padding: 6px;

    td:first-child {
      font: normal normal bold 14px/22px Inter;
    }
    td {
      font: normal normal normal 14px/22px Inter;
    }
  }
  .header {
    height: 29px;
    border-radius: 5px;
    background: ${props => props.theme.colors.colorf3f5f9};

    margin-bottom: 9px;
  }

  ${VerticalStyledScrollBar}
`

export const LoadingContainer = styled.div`
  position: relative;
  padding: 1rem;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const AlertMessage = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${props => props.theme.colors.color6b7786};
    font-family: Inter;
    font-size: 12px;
    font-weight: 22px;
    text-align: center;
  }
`
